<template>
  <section :class="{landing: welcome}" class="login-body">
    <div v-if="welcome" class="login-landing">
      <div class="inner">
        <div class="versions-wrapper">
          <div class="version-outer">
            <div class="version">
              <i class="fa fa-walking logo-font"></i>
              <h1>Uniom</h1>
              <h2>Beléptető rendszer - v1</h2>
              <button class="button with-icon" type="button" v-on:click="welcome = false"><i class="fa fa-sign-in-alt"></i>Tovább (Korábbi verzió)</button>
            </div>
          </div>
          <div class="version-outer">
            <div class="version">
              <img class="logo" src="assets/img/shield-key.svg">
              <h1>Uniom</h1>
              <h2 class="v2">Beléptető rendszer - <span>v2</span></h2>
              <button class="button with-icon" type="button" v-on:click="redirect('https://beleptetoadmin.sze.hu')"><i class="fa fa-sign-in-alt"></i>Tovább (Új verzió)</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section v-else>
      <div v-if="shibLogin && !shib_error" class="login-panel shib">
        <iframe src="https://belepteto.sze.hu/Shibboleth.sso/Login?target=https://belepteto.sze.hu/api/shib_login_redirect" width="800" height="653" frameborder="0"></iframe>
        <div class="login-panel-foot">
          <button class="button" type="button" v-on:click="shibLogin = false">Címtár nélküli bejelentkezés</button>
        </div>
      </div>
      <div v-else-if="shibLogin && shib_error" class="login-panel">
        <iframe v-show="false" :src="shibLogoutUrl" width="0px" height="0px" scrolling="no" />
        <div class="login-panel-background">
          <div class="login-panel-head">
            <h1><i class="fa fa-walking"></i><h1>BR<span> - Beléptető rendszer</span></h1></h1>
            <p>A Széchenyi István Egyetem beléptető menedzsment felülete.</p>
          </div>
          <div class="login-panel-body">
            <h2><strong>Hiba!</strong></h2>
            <h2 style="padding-bottom: 40px;">{{ shib_error }}</h2>
            <button class="button with-icon" type="button" v-on:click="relogin"><i class="fa fa-redo-alt"></i>Szeretnék újra bejelentkezni</button>
          </div>
        </div>
      </div>
      <div v-else class="login-panel">
        <div class="login-panel-background">
          <div class="login-panel-head">
            <h1><i class="fa fa-walking"></i><h1>BR<span> - Beléptető rendszer</span></h1></h1>
            <p>A Széchenyi István Egyetem beléptető menedzsment felülete.</p>
          </div>
          <div class="login-panel-body">
            <h2>Bejelentkezés</h2>
            <form>
              <inputbox id="email" label="Email" @keydownEnter="login" v-bind:errors="errors" name="email" v-model="form.email"></inputbox>
              <passwordbox id="password" label="Jelszó" @keydownEnter="login" v-bind:errors="errors" name="password" v-model="form.password"></passwordbox>
              <div class="form-actions clearfix">
                <button class="button with-icon" type="button" v-on:click="login"><i class="fa fa-sign-in-alt"></i>Bejelentkezés</button>
              </div>
            </form>
          </div>
        </div>
        <div class="login-panel-foot">
          <button class="button" type="button" v-on:click="shibLogin = true">Címtáras bejelentkezés</button>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
export default {
  data: function () {
    return {
      shibLogin: true,
      welcome: true,
      form: {
        email: '',
        password: ''
      },
      errors: [
      ],
      shib_error: false
    }
  },
  computed: {
    shibLogoutUrl: function() {
      return location.protocol+"//"+location.host+"/Shibboleth.sso/Logout";
    }
  },
  mounted() {
    const _this = this;
    // Listen to message from child window
    $(window).on('message', function(message) {
      if (message.originalEvent.data.apikey) {
        const user = message.originalEvent.data;
        _this.$root.user = user;
        sessionStorage.setItem('belepteto_apikey', user.apikey);
        _this.$router.push('/home');
      } else if (message.originalEvent.data.shiberror_msg) {
        _this.shib_error = message.originalEvent.data.shiberror_msg;
      }
    });
  },
  methods: {
    // IE 8 fix
    bindEvent: function(element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler);
      }
    },
    login: function(event) {
      var _this = this;

      this.$root.ajax('users/login', {
        method: 'POST',
        data: this.form,
        success: function(response) {
          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            _this.$root.user = response.user;
            sessionStorage.setItem("belepteto_apikey", response.user.apikey);
            _this.$router.push({path: '/home'});
          }
        }
      });
    },
    relogin: function() {
      this.$router.go();
    },
    redirect: function(url) {
      window.location.href = url;
    }
  }
}
</script>



// WEBPACK FOOTER //
// login.vue?49fd3b01